import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "component-controller"
  }, [_c("div", {
    ref: "titleRef",
    staticClass: "controller-title"
  }, [_vm._v(_vm._s(_vm.title))]), typeof _vm.components[_vm.index].draggable == "undefined" ? _c("div", {
    staticClass: "controller-aside",
    class: {
      "is-selected": _vm.design_selected_id === _vm.id
    }
  }, [_c("a-icon", {
    class: {
      disabled: _vm.components[0].id === _vm.design_selected_id || _vm.components[_vm.index].draggable === false || _vm.components[_vm.index - 1] && typeof _vm.components[_vm.index - 1].draggable !== "undefined" && _vm.components[_vm.index - 1].draggable == false
    },
    attrs: {
      type: "caret-up"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("design/componentMoveUp", _vm.id);
      }
    }
  }), _c("a-icon", {
    class: {
      disabled: _vm.components[_vm.components.length - 1].id === _vm.design_selected_id || _vm.components[_vm.index].draggable === false || _vm.components[_vm.index + 1] && _vm.components[_vm.index + 1].name === "Footer"
    },
    attrs: {
      type: "caret-down"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("design/componentMoveDown", _vm.id);
      }
    }
  }), _c("span", {
    staticClass: "seq"
  }), _c("a-icon", {
    class: {
      disabled: _vm.components[_vm.index].draggable === false
    },
    attrs: {
      type: "delete"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("design/componentDelete", _vm.id);
      }
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "component-container"
  }, [_c("div", {
    ref: "containerRef",
    class: {
      "design-component": true,
      "is-active": _vm.design_selected_id === _vm.id && _vm.show_component_form === true,
      "is-hover": _vm.in_drag == false && _vm.mouse_hover_id === _vm.id,
      "is-selected": _vm.design_selected_id === _vm.id
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("design/form_open", _vm.id);
      }
    }
  }, [_vm._t("default")], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };